import styled from '@emotion/styled';
import { ChangeEvent, FC, ReactNode, useRef } from 'react';
import { renameUploadFile } from 'helpers/utils';

export interface CustomFileUploadProps {
  /** ค่า accept ของ input เช่น "image/jpeg,image/png,application/pdf" หรือ ".pdf,.jpg" */
  accept?: string;
  disabled?: boolean;
  /** เรียกเมื่อผู้ใช้เลือกไฟล์หนึ่งไฟล์ (หลังเลือกแล้ว input ถูก reset เพื่อเลือกไฟล์เดิมซ้ำได้) */
  onFileSelected: (file: File) => void;
  /** รับฟังก์ชันเปิด dialog — ส่งเข้า onClick ของปุ่มหรือพื้นที่กด */
  children: (openFileDialog: () => void) => ReactNode;
}

/**
 * Custom upload โดยไม่ใช้ antd Upload — ควบคุม UX / สไตล์เอง
 */
const CustomFileUpload: FC<CustomFileUploadProps> = ({
  accept = 'image/jpeg,image/jpg,image/png,image/webp,application/pdf',
  disabled,
  onFileSelected,
  children,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openFileDialog = () => {
    if (disabled) return;
    inputRef.current?.click();
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (file) {
      // change file name
      onFileSelected(renameUploadFile(file));
    }
  };

  return (
    <>
      <HiddenFileInput
        ref={inputRef}
        type="file"
        accept={accept}
        disabled={disabled}
        onChange={handleChange}
        tabIndex={-1}
        aria-hidden
      />
      {children(openFileDialog)}
    </>
  );
};

export default CustomFileUpload;

const HiddenFileInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
